var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Loader, Overlay } from "@gravity-ui/uikit";
import { eventBus } from "@/context/shared/eventBus";
import { newGuid } from "@/tools/guid";
/** Отображение лоадера поверх контента */
export var LoadingOverlay = function () {
    // Очередь лоадеров
    var _a = useState([]), queue = _a[0], setQueue = _a[1];
    var startLoadingHandler = function (key) {
        setQueue(function (prev) { return __spreadArray(__spreadArray([], prev.filter(function (o) { return o !== key; }), true), [key], false); });
    };
    var stopLoadingHandler = function (key) {
        setQueue(function (prev) { return prev.filter(function (o) { return o !== key; }); });
    };
    useEffect(function () {
        eventBus.on("pendingStart", startLoadingHandler);
        eventBus.on("pendingStop", stopLoadingHandler);
        return function () {
            eventBus.off("pendingStart", startLoadingHandler);
            eventBus.off("pendingStop", stopLoadingHandler);
            setQueue([]);
        };
    }, []);
    // Если очередь не пустая, то отображаем лоадер
    return queue.length ? (_jsx(Overlay, { visible: true, background: "float", className: "overlay--loading", children: _jsx(Loader, {}) })) : null;
};
/** Добавление лоадера в очередь */
export var Loading = function (props) {
    var queueKey = useMemo(function () { return props.loadingKey || newGuid(); }, [props.loadingKey]);
    useEffect(function () {
        if (queueKey && props.isActive !== false) {
            eventBus.emit("pendingStart", queueKey);
        }
        if (queueKey && props.isActive === false) {
            eventBus.emit("pendingStop", queueKey);
        }
        return function () {
            if (queueKey) {
                eventBus.emit("pendingStop", queueKey);
            }
        };
    }, [queueKey, props.isActive]);
    return null;
};
